import React from "react";
import PropTypes from "prop-types";
import styles from "./styles";

import {
  Box,
  Collapse,
  Divider,
  Drawer,
  Grid,
  InputBase,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import PersonIcon from "@material-ui/icons/Person";

const DrawerAppBar = props => {
  const classes = styles();
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const [openM, setOpenM] = React.useState(false);

  const [state, setState] = React.useState({});

  // const handleClick = () => {
  //   setOpenM(!openM);
  // };

  const data = [
    {
      id: 1,
      name: "Planes",
      type: "primary",
      children: [
        {
          id: 1.1,
          name: "Cobertura en Ecuador",
          type: "secondary",

          children: [
            {
              id: 1.2,
              name: "Ecuador",
              type: "secondary",
              children: [
                {
                  id: 1.11,
                  name: "Único",
                  path: `/plan-unico/`
                },
                {
                  id: 1.12,
                  name: "Escencial",
                  path: `/plan-esencial/`
                },
                {
                  id: 1.13,
                  name: "Práctico",
                  path: `/plan-practico/`
                },
                {
                  id: 1.14,
                  name: "Ideal",
                  path: `/plan-ideal/`
                }
              ]
            },
            {
              id: 1.3,
              name: "Ecuador y Clínica U. de Navarra",
              type: "secondary",
              children: [
                {
                  id: 1.31,
                  name: "Élite",
                  path: `/plan-elite/`
                },
                {
                  id: 1.32,
                  name: "Priviliegio",
                  path: `/plan-privilegio/`
                }
              ]
            },
            {
              id: 1.4,
              name: "Comparar",
              type: "secondary",
              children: [
                {
                  id: 1.41,
                  name: "Comparar y elige el mejor plan",
                  path: `/comparador/`
                }
              ]
            }
          ]
        },
        {
          id: 1.5,
          name: "Cobertura médica mundial",
          type: "secondary",

          children: [
            {
              id: 1.51,
              name: "Experience Word",
              path: `https://www.experience.ec/`,
              link: true
            }
          ]
        },
        {
          id: 1.6,
          name: "Cobertura médica frente al cáncer",
          type: "secondary",

          children: [
            {
              id: 1.61,
              name: "Plan Oncocare",
              path: `/oncocare/`
            }
          ]
        },

        {
          id: 1.7,
          name: "Cobertura de gastos mayores",
          type: "secondary",

          children: [
            {
              id: 1.71,
              name: "Respaldo Total Nacional",
              path: `/respaldototal/`
            }
          ]
        },
        {
          id: 1.8,
          name: "Cobertura dental",
          type: "secondary",

          children: [
            {
              id: 1.81,
              name: "Esencial",
              path: `/saludental-esencial/`
            },
            {
              id: 1.82,
              name: "Plan Dental Master",
              path: `/saludental-master/`
            },
            {
              id: 1.83,
              name: "Saludental Privilegio",
              path: `/saludental-privilegio/`
            }
          ]
        },
        {
          id: 1.9,
          name: "Servicios adicionales",
          type: "secondary",

          children: [
            {
              id: 1.91,
              name: "SaludsaVida",
              path: `/saludsavida/`
            },
            {
              id: 1.92,
              name: "SaludsaTravel",
              path: `/saludsatravel/`
            },
            {
              id: 1.93,
              name: "Desempleo",
              path: `/mas-servicios/`
            },
            {
              id: 1.94,
              name: "Exequial",
              path: `/exequial/`
            },
            {
              id: 1.95,
              name: "MuerteAccidental",
              path: `/mas-servicios/`
            },
            {
              id: 1.96,
              name: "EnfermedadesGraves",
              path: `/mas-servicios/`
            }
          ]
        }
      ]
    },

    {
      id: 2,
      name: "Vitality",
      type: "primary",
      children: [
        {
          id: 2.1,
          name: "¿Qué es Vitality?",
          path: `/vitality/`
        },
        {
          id: 2.2,
          name: "¿Cómo ganar el 20% cashback en tu plan médico?",
          path: `/vitality/premios/#tabAnuales`
        },
        {
          id: 2.3,
          name: "¿Cómo ganar el 100% de cashback en un reloj gármin?",
          path: `/vitality/premios/#tabMensuales`
        },
        {
          id: 2.4,
          name: "¿Cómo ganar premios todas las semanas?",
          path: `/vitality/premios/#tabSemanales`
        },
        {
          id: 2.5,
          name: "¿Cómo registrarme?",
          path: `/se-miembro/`
        },
        {
          id: 2.6,
          name: "Descarga el App",
          path: `http://onelink.to/g7dp45`
        },
        {
          id: 2.7,
          name: "Tutoriales",
          path: `/videos-sincronizacion/`
        },
        {
          id: 2.8,
          name: "Guía de uso Vitality",
          path: `/ayuda-vitality/`
        }
      ]
    },

    {
      id: 3,
      name: "Asistencia médica",
      type: "primary",
      children: [
        {
          id: 3.1,
          name: "¿Que es DrSalud?",
          type: "secondary",

          children: [
            {
              id: 3.2,
              name: "¿Como accedo a DrSalud?",
              type: "secondary",

              children: [
                {
                  id: 3.21,
                  name: "DrSalud",
                  path: `/drsalud/`
                },
                {
                  id: 3.22,
                  name: "WhatsApp",
                  path: `https://api.whatsapp.com/send?phone=+593939874000&text=Hola,%20soy%20cliente%20de%20Saludsa,%20necesito%20asesor%C3%ADa%20m%C3%A9dica.%3C!--%20[et_pb_line_break_holder]%20--%3E`,
                  link: true
                },
                {
                  id: 3.23,
                  name: "Portal de clientes",
                  path: `https://www.saludsapersonas.com/portalclientes/Account/Login`,
                  link: true
                },
                {
                  id: 3.24,
                  name: "Contact Center",
                  path: `tel:6020920`,
                  link: true
                }
              ]
            },
            {
              id: 3.3,
              name: "Guía médica",
              path: `http://guia.drsalud.com/#/guiaMedica`,
              link: true
            },
            {
              id: 3.4,
              name: "Centro de ayuda",
              path: `https://serviciosaludsa.zendesk.com/hc/es`,
              link: true
            },
            {
              id: 3.5,
              name: "Descarga la App",
              path: `https://onelink.to/9fxba5`,
              link: true
            }
          ]
        },

        {
          id: 3.6,
          name: "¿Quieres evaluar tus síntomas?",
          type: "secondary",

          children: [
            {
              id: 3.61,
              name: "Evaluador de síntomas",
              path: `/evaluador-sintomas/`
            },
            {
              id: 3.62,
              name: "Descarga la App",
              path: `https://onelink.to/9fxba5`,
              link: true
            }
          ]
        },
        {
          id: 3.7,
          name: "¿Necesitas un médico?",
          type: "secondary",

          children: [
            {
              id: 3.71,
              name: "Consulta médica en línea",
              path: `http://guia.drsalud.com/#/atencionesMedicas`,
              link: true
            },
            {
              id: 3.72,
              name: "Médico a domicilio",
              path: `https://guia.drsalud.com/#/atencionesMedicas#medicoDomicilio`
            },
            {
              id: 3.73,
              name: "Agendamiento de citas",
              path: `/consulta_medica_en_linea/`
            },
            {
              id: 3.74,
              name: "Solicita tu ODA",
              path: `/oda/`
            },
            {
              id: 3.75,
              name: "Segunda opinión médica",
              path: `/segunda-opinion-medica/`
            },
            {
              id: 3.76,
              name: "Centro de ayuda",
              path: `https://serviciosaludsa.zendesk.com/hc/es`,
              link: true
            },
            {
              id: 3.77,
              name: "Descarga la App",
              path: `https://onelink.to/9fxba5`,
              link: true
            }
          ]
        },
        {
          id: 3.8,
          name: "¿Necesitas una hospitalización?",
          type: "secondary",

          children: [
            {
              id: 3.81,
              name: "Solicitud de cobertura hospitalaria en línea",
              path: `https://serviciosaludsa.zendesk.com/hc/es/articles/360035875792-Solicitud-de-Cobertura-en-L%C3%ADnea`,
              link: true
            },
            {
              id: 3.82,
              name: "Asesoría hospitalaria (Videoconsulta)",
              path: `/consulta-medica-en-linea/`
            },
            {
              id: 3.83,
              name: "Consultar tarifario",
              path: `/estimador-de-valores/`
            },
            {
              id: 3.84,
              name: "Centro de ayuda",
              path: `https://serviciosaludsa.zendesk.com/hc/es`,
              link: true
            },
            {
              id: 3.85,
              name: "Descarga la App",
              path: `https://onelink.to/9fxba5`,
              link: true
            }
          ]
        },
        {
          id: 3.9,
          name: "¿Necesitas medicinas?",
          type: "secondary",

          children: [
            {
              id: 3.91,
              name: "Medicinas cero trámites",
              path: `/home_care/`
            },
            {
              id: 3.92,
              name: "Medicinas a domicilio",
              path: `https://guia.drsalud.com/#/buscador/farmacia`,
              link: true
            },
            {
              id: 3.93,
              name: "Centro de ayuda",
              path: `https://serviciosaludsa.zendesk.com/hc/es`,
              link: true
            },

            {
              id: 3.94,
              name: "Descarga la App",
              path: `https://onelink.to/9fxba5`,
              link: true
            }
          ]
        },
        {
          id: 4,
          name: "¿Necesitas exámenes médicos?",
          type: "secondary",

          children: [
            {
              id: 4.1,
              name: "Exámenes a domicilio (HomeCare)",
              path: `/home_care/`
            },
            {
              id: 4.12,
              name: "Exámenes de laboratorio e imagen cero trámites",
              path: `https://guia.drsalud.com/#/buscador/laboratorioClinico`,
              link: true
            },
            {
              id: 4.13,
              name: "Centro de ayuda",
              path: `https://serviciosaludsa.zendesk.com/hc/es`,
              link: true
            },

            {
              id: 4.14,
              name: "Descarga la App",
              path: `https://onelink.to/9fxba5`,
              link: true
            }
          ]
        },
        {
          id: 4.2,
          name: "Servicios médicos a domicilio HomeCare",
          type: "secondary",

          children: [
            {
              id: 4.21,
              name: "HomeCare",
              path: `/home-care/`
            },
            {
              id: 4.22,
              name: "Consulta médica en línea",
              path: `/consulta-medica-en-linea/`
            },
            {
              id: 4.23,
              name: "Medicina a domicilio",
              path: `/home-care/`
            },
            {
              id: 4.24,
              name: "Laboratorio clínico e imagen",
              path: `https://guia.drsalud.com/#/buscador/laboratorioClinico`,
              link: true
            },
            {
              id: 4.25,
              name: "Enfermería a domicilio",
              path: `https://guia.drsalud.com/#/buscador/busquedaGeneral/Enfermeria`,
              link: true
            },
            {
              id: 4.25,
              name: "Centro de ayuda",
              path: `https://serviciosaludsa.zendesk.com/hc/es`,
              link: true
            },

            {
              id: 4.26,
              name: "Descarga la App",
              path: `https://onelink.to/9fxba5`,
              link: true
            }
          ]
        }
      ]
    },

    {
      id: 5,
      name: "Canales y servicios",
      type: "primary",
      children: [
        {
          id: 5.1,
          name: "Nuestros canales",
          type: "secondary",

          children: [
            {
              id: 5.12,
              name: "AppSaludsa",
              path: `http://onelink.to/ag439w`,
              link: true
            },
            {
              id: 5.13,
              name: "AppExperience",
              path: `http://onelink.to/4bd4c4`,
              link: true
            },
            {
              id: 5.14,
              name: "Oficina virtual",
              path: `https://www.videoask.com/f1u1aaeh4`,
              link: true
            },
            {
              id: 5.15,
              name: "Portal de clientes",
              path: `https://www.videoask.com/f1u1aaeh4`,
              link: true
            },
            {
              id: 5.16,
              name: "Iniciar chat en línea",
              path: `https://servicios.saludsa.com.ec/ChatGenesis/informacion.html?x=76&y=10`,
              link: true
            },
            {
              id: 5.17,
              name: "WhatsApp",
              path: `https://api.whatsapp.com/send?phone=+593989404239&text=Hola,%20soy%20cliente%20de%20Saludsa,%20necesito%20servicio%20al%20cliente.`,
              link: true
            },
            {
              id: 5.18,
              name: "Contact center",
              path: `tel: 026020920`,
              link: true
            }
          ]
        },
        {
          id: 6.1,
          name: "Nuestros servicios",
          type: "secondary",

          children: [
            {
              id: 6.12,
              name: "Reembolso On-line",
              path: `/reembolso-online/`
            },
            {
              id: 6.13,
              name: "Saludsa Pay",
              path: `/saludsa-pay-2/`
            }
          ]
        }
      ]
    },
    {
      id: 7,
      name: "Como usar mi plan",
      type: "primary",
      children: [
        {
          id: 7.1,
          name: "Como usar mi plan",
          path: `/como-usar-tu-plan/`
        }
      ]
    },
    {
      id: 8,
      name: "¿Quiénes somos?",
      type: "primary",
      path: `/quienes-somos/`,
      unique: true
    },
    {
      id: 9,
      name: "Contactos",
      type: "primary",
      path: `/contactos/`,
      unique: true
    },
    {
      id: 10,
      name: "Blog",
      type: "primary",
      path: `https://blog.saludsa.com/?__hstc=213659531.f1a25314a93e8960690d4f87c24f8f56.1620657222726.1620941636247.1620944753379.9&__hssc=213659531.5.1620944753379&__hsfp=143711594`,
      link: true,
      unique: true
    }
    // {
    //   id: 9,
    //   name: "Acceso a clientes",
    //   type: "primary",
    //   path: `#`,
    //   link: true,
    //   unique: true,
    //   client: true
    // }
  ];

  const handleClick = item => {
    console.log("CategoriesList2 -> item", item);
    setSelectedIndex(item.id);

    setState(state => ({
      ...state,
      [item.id]: !state[item.id]
    }));
  };

  const handleListItemClick = (event, item) => {
    console.log("CategoriesList1 -> item", item);
    // href={`${process.env.REACT_APP_URL_HOST}${path}`}
    if (!item.link && !item.divider) {
      window.location.href = `${process.env.REACT_APP_URL_HOST}${item.path}`;
    } else if (!item.divider) {
      window.location.href = item.path;
    }
    setSelectedIndex(item.categoryId);
  };

  const renderCategoriesList = dataP => {
    return dataP.map(subOption => {
      if (!subOption.children) {
        return (
          <div key={subOption.id} style={{ paddingLeft: "0px" }}>
            <ListItem
              style={{ borderBottom: "1px solid #ececec" }}
              button
              key={subOption.id}
              selected={selectedIndex === subOption.id}
              onClick={event => handleListItemClick(event, subOption)}
              className={
                selectedIndex === subOption.id
                  ? classes.selected
                  : subOption.divider
                  ? classes.dividerClass
                  : subOption.unique
                  ? classes.uniqueLinkPrimary
                  : ""
              }
            >
              {subOption.client && (
                <PersonIcon
                  className={classes.iconUrl}
                  style={{ marginRight: "15px", fontSize: 30 }}
                />
              )}
              {/* <Link to={subOption.name} classid={classes.links}> */}
              <ListItemText
                className={
                  subOption.type === "primary"
                    ? classes.textPrimary
                    : classes.textSecondary
                }
                style={{
                  paddingLeft: "0px"
                }}
                inset
                primary={subOption.name}
              />
              {subOption.path && !subOption.divider && !subOption.unique && (
                <ArrowForwardIosIcon className={classes.iconUrl} />
              )}
              {/* </Link> */}
            </ListItem>
          </div>
        );
      }
      return (
        <div key={subOption.id} style={{ paddingLeft: "0px" }}>
          <ListItem
            style={{ borderBottom: "1px solid #ececec" }}
            button
            selected={selectedIndex === subOption.id}
            onClick={() => handleClick(subOption)}
            className={selectedIndex === subOption.id ? classes.selected : ""}
          >
            <ListItemText
              //   className={
              //     subOption.type === "primary"
              //       ? classes.textPrimary
              //       : classes.textSecondary
              //   }
              className={classes.textPrimary}
              style={{ paddingLeft: "0px" }}
              inset
              primary={subOption.name}
            ></ListItemText>
            {state[subOption.id] ? (
              <ExpandLess />
            ) : (
              <ExpandMore className={classes.colorExpandMore} />
            )}
          </ListItem>
          <Collapse
            in={state[subOption.id]}
            timeout="auto"
            unmountOnExit
            style={{ backgroundColor: "#f3f3f3" }}
          >
            <div style={{ paddingLeft: "10px" }}>
              {renderCategoriesList(subOption.children)}
            </div>
          </Collapse>
        </div>
      );
    });
  };

  return (
    <Drawer
      className={classes.drawer}
      classes={{ paper: classes.drawerPaper }}
      anchor="top"
      variant={props.variant}
      open={props.open}
      onClose={props.onClose && props.onClose}
    >
      <Divider />
      <Grid container className={classes.containerDrawer}>
        {renderCategoriesList(data)}

        {/* <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          className={classes.listItem}
        >
          <ListItem button onClick={handleClick}>
            <ListItemText primary="Inbox" />
            {openM ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openM} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button className={classes.nested}>
                <ListItemText primary="Starred" />
              </ListItem>
            </List>
          </Collapse>
        </List> */}
      </Grid>
    </Drawer>
  );
};

DrawerAppBar.propTypes = {
  variant: PropTypes.any,
  open: PropTypes.bool,
  onClose: PropTypes.any
};

export default DrawerAppBar;
